import styled from 'styled-components';

export const HelpLink = styled.a`
  cursor: pointer;
  line-height: 1;
  vertical-align: middle;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    svg {
      rect {
        stroke: #4080e2;
      }

      path {
        fill: #4080e2;
      }
    }
  }
`;
